export enum FeatureFlags {
  "AiVideoQuestions" = "eup-ai-video-questions",
  "LimitEventRegistration" = "limit-event-registration",
  DontCopyFlow = "dont-copy-flows",
  EmbeddedVideos = "embedded-videos",
  EndOfFlowLink = "end-of-flow-link",
  UsingGroupsInEupTeams = "using-groups-in-eup-teams",
}
